import { useNavigate } from "react-router-dom";
import http from "../../services/api";
import store from "../index";
import * as types from "../types/cadastro";
import { autenticarUsuario } from "./usuario";

export const cadastroSite = (item, navigate) => {
  store.dispatch({ type: types.CADASTRO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.post(`/api/v2/app/cliente`, item).then(
      async (response) => {
        return autenticarUsuario(item.cpf, item.password)
          .then(() => {
            navigate("/app/assinatura", { replace: true });
            store.dispatch([{ type: types.CADASTRO_LOADING, payload: false }]);
            resolve();
          })
          .catch((e) => {
            throw e;
          });
      },
      (e) => {
        store.dispatch([{ type: types.CADASTRO_LOADING, payload: false }]);
        reject(
          e.response
            ? e.response.data
            : "Não foi possível efetuar o cadastro, tente novamente mais tarde."
        );
      }
    );
  });
};

export const cadastroCartao = (item) => {
  store.dispatch({ type: types.CADASTRO_CARTAO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.post(`/api/v2/app/assinatura`, item).then(
      (response) => {
        store.dispatch([
          { type: types.CADASTRO_CARTAO_LOADING, payload: false },
        ]);
        resolve(response.data);
      },
      (e) => {
        store.dispatch([
          { type: types.CADASTRO_CARTAO_LOADING, payload: false },
        ]);
        reject(e);
      }
    );
  });
};


export const EditarDadosCartao = (item, navigate) => {
  store.dispatch({ type: types.CADASTRO_CARTAO_LOADING, payload: true });
  return new Promise((resolve, reject) => {
    http.patch(`/api/v2/app/assinatura/cartao`, item).then(
      (response) => {
        store.dispatch([
          { type: types.CADASTRO_CARTAO_LOADING, payload: false },
        ]);
        resolve(response.data);
      },
      (e) => {
        store.dispatch([
          { type: types.CADASTRO_CARTAO_LOADING, payload: false },
        ]);
        reject(e);
      }
    );
  });
};

export function actionNumeroDaSorte() {
  return new Promise((resolve, reject) => {
    http.get(`/api/v2/mapfre-numero`).then(
      (response) => {
        store.dispatch({
          type: types.SET_NUMERO_DA_SORTE,
          payload: response.data,
        });
        resolve();
      },
      (e) => {
        reject();
      }
    );
  });
}

export function ValidarCpf(cpf) {
  return new Promise((resolve, reject) => {
    http.get(`/api/v2/app/cliente/verificacao/${cpf}`).then(
      (response) => {
        resolve(response);
      },
      (e) => {
        reject(e.response);
      }
    );
  });
}
